import * as React from 'react';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
const Label = ({
  required,
  target,
  text,
  ...extraProps
}) => /*#__PURE__*/_jsx("label", {
  className: clsx({
    'label-required': required
  }),
  htmlFor: target,
  ...extraProps,
  children: text
});
export default Label;